export const pathGroups = [
  {
    id: "path1",
    groups: ["gov", "node1", "node4", "node7", "node10"]
  },
  {
    id: "path2a",
    groups: ["gov", "node1", "node4", "node7", "node11"]
  },
  {
    id: "path2b",
    groups: ["gov", "node1", "node4", "node7", "node11"]
  },
  {
    id: "path3",
    groups: ["gov", "node1", "node4", "node8", "node10"]
  },
  {
    id: "path4",
    groups: ["gov", "node1", "node4", "node8", "node12"]
  },
  {
    id: "path5",
    groups: ["gov", "node1", "node4", "node8", "node11"]
  },
  {
    id: "path6",
    groups: ["gov", "node1", "node4", "node8", "node13"]
  },
  {
    id: "path7",
    groups: ["donor", "node2", "node4", "node7", "node10"]
  },
  {
    id: "path8a",
    groups: ["donor", "node2", "node4", "node7", "node11"]
  },
  {
    id: "path8b",
    groups: ["donor", "node2", "node4", "node7", "node11"]
  },
  {
    id: "path9",
    groups: ["donor", "node2", "node4", "node8", "node10"]
  },
  {
    id: "path10",
    groups: ["donor", "node2", "node4", "node8", "node11"]
  },
  {
    id: "path11",
    groups: ["donor", "node2", "node4", "node8", "node12"]
  },
  {
    id: "path12",
    groups: ["donor", "node2", "node4", "node8", "node13"]
  },
  {
    id: "path13a",
    groups: ["donor", "node2", "node5", "node7", "node10"]
  },
  {
    id: "path13b",
    groups: ["donor", "node2", "node5", "node7", "node10"]
  },
  {
    id: "path14a",
    groups: ["donor", "node2", "node5", "node7", "node11"]
  },
  {
    id: "path14b",
    groups: ["donor", "node2", "node5", "node7", "node11"]
  },
  {
    id: "path14c",
    groups: ["donor", "node2", "node5", "node7", "node11"]
  },
  {
    id: "path15",
    groups: ["donor", "node2", "node5", "node8", "node10"]
  },
  {
    id: "path16",
    groups: ["donor", "node2", "node5", "node8", "node11"]
  },
  {
    id: "path17",
    groups: ["donor", "node2", "node5", "node8", "node12"]
  },
  {
    id: "path18",
    groups: ["donor", "node2", "node5", "node8", "node13"]
  },
  {
    id: "path19",
    groups: ["private", "node3", "node6", "node8", "node10"]
  },
  {
    id: "path20",
    groups: ["private", "node3", "node6", "node8", "node11"]
  },
  {
    id: "path21",
    groups: ["private", "node3", "node6", "node8", "node12"]
  },
  {
    id: "path22",
    groups: ["private", "node3", "node6", "node8", "node13"]
  },
  {
    id: "path23a",
    groups: ["private", "node3", "node6", "node9", "node12"]
  },
  {
    id: "path23b",
    groups: ["private", "node3", "node6", "node9", "node12"]
  },
  {
    id: "path24",
    groups: ["private", "node3", "node6", "node9", "node13"]
  }
];

export const junctionGroups = [
  {
    id: "node1",
    groups: ["node4", "node7", "node8", "node10", "node11", "node12", "node13"]
  },
  {
    id: "node2",
    groups: [
      "node4",
      "node5",
      "node7",
      "node8",
      "node10",
      "node11",
      "node12",
      "node13"
    ]
  },
  {
    id: "node3",
    groups: ["node6", "node8", "node9", "node10", "node11", "node12", "node13"]
  },
  {
    id: "node4",
    groups: [
      "node1",
      "node2",
      "node7",
      "node8",
      "node10",
      "node11",
      "node12",
      "node13"
    ]
  },
  {
    id: "node5",
    groups: ["node2", "node7", "node8", "node10", "node11", "node12", "node13"]
  },
  {
    id: "node6",
    groups: [
      "node3",
      "node6",
      "node8",
      "node9",
      "node10",
      "node11",
      "node12",
      "node13"
    ]
  },
  {
    id: "node7",
    groups: ["node1", "node2", "node4", "node5", "node10", "node11"]
  },
  {
    id: "node8",
    groups: [
      "node1",
      "node2",
      "node3",
      "node4",
      "node5",
      "node6",
      "node10",
      "node11",
      "node12",
      "node13"
    ]
  },
  {
    id: "node9",
    groups: ["node3", "node6", "node12", "node13"]
  },
  {
    id: "node10",
    groups: [
      "node1",
      "node2",
      "node3",
      "node4",
      "node5",
      "node6",
      "node7",
      "node8"
    ]
  },
  {
    id: "node11",
    groups: [
      "node1",
      "node2",
      "node3",
      "node4",
      "node5",
      "node6",
      "node7",
      "node8"
    ]
  },
  {
    id: "node12",
    groups: [
      "node1",
      "node2",
      "node3",
      "node4",
      "node5",
      "node6",
      "node8",
      "node9"
    ]
  },
  {
    id: "node13",
    groups: [
      "node1",
      "node2",
      "node3",
      "node4",
      "node5",
      "node6",
      "node8",
      "node9"
    ]
  }
];
